import * as d3 from 'd3'

export default {
  data: () => ({

  }),

  methods: {

    gmx_Progress(tot, act) {

      let prog = (tot==0 || act==0) ? 0 : act / tot
      return prog * 100
    },

    gmx_numFormat(val, unit){
      let reVal = ''
      switch(unit) {
        case '$': 
          reVal = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          break
        case '%':
          reVal = `${val}%`
          break
        default:
          reVal = val
      }
      return reVal
    },


    gmx_changeDate(format, str){
      let _year = null
      let _month = null
      let _day = null
      let result = null

      switch(format){
        case '/': 
          _month = Number(str.substr(5,2))
          _day = Number(str.substr(8,2))
          result = `${_month}/${_day}`
        break;
      }
      return result
    },


    gmx_BarCoordinates(mx, bars, gap) {
      let barx = []

      bars.forEach((d,i)=>{
        let sumBar = d * (i-(bars.length/2))
        let sumGap = gap * (i-((bars.length-1)/2))
        barx.push(mx + sumBar + sumGap)
      })
      return barx
    },


    // Updated:  2025-06-20
    gmx_tableCoordinates(dir, columns, padding, sx=0) {
      if(dir=='x') {
        let x = sx
        columns.forEach(d=> {
          d.sx = x; 
          d.mx = x + (d.width/2)
          d.ex = x + d.width
          if(d.align) {
            if(d.align == 'start') d.tx = x + padding
            if(d.align == 'middle') d.tx = x + (d.width/2)
            if(d.align == 'end') d.tx = x + d.width - padding
          }
          x = x + d.width
        })
        return x
      } else if(dir=='y') {
        let y = 0
        columns.forEach(d=> {
          d.sy = y
          d.my = y + (d.height/2)
          d.ey = y + d.height
          y = y + d.height
        })
        return y
      }
    },


    

  }
}
